/// <reference path="corporate-api.js" />
import httpClient from './httpClient';

const getOutstandingBookingChargeItem = (bookingId) => httpClient.get('/api/v2/BookingChargeItem/GetOutstandingBookingChargeItem', { params: { bookingId } });

const getTransactionListByBookingId = (BookingId) => httpClient.get('/api/v2/BookingChargeItem/GetTransactionListByBookingId', { params: { BookingId } });

const getPaidBookingChargeItem = (BookingId, paymentCategoryId) => httpClient.get('/api/v2/BookingChargeItem/GetPaidBookingChargeItem', { params: { BookingId, paymentCategoryId } });

const getRoomChargeItem = (roomStayId, allChargeRoom) => httpClient.get('/api/v2/BookingChargeItem/GetRoomChargeItem', { params: { roomStayId, allChargeRoom } });

const getSecurityDepositItems = (BookingId) => httpClient.get('/api/v2/BookingChargeItem/GetSecurityDepositItems', { params: { BookingId } });



const addCancellation = (model) => httpClient.post('/api/v2/BookingChargeItem/AddCancellation', model);

const addDiscount = (model) => httpClient.post('/api/v2/BookingChargeItem/AddDiscount', model);

const addWaived = (model) => httpClient.post('/api/v2/BookingChargeItem/AddWaived', model);

const postCharge = (model) => httpClient.post('/api/v2/BookingChargeItem/PostCharge', model);

const transferCharge = (model) => httpClient.post('/api/v2/BookingChargeItem/TransferCharge', model);

const forfeitSecurityDeposit = (model) => httpClient.post('/api/v2/BookingChargeItem/ForfeitSecurityDeposit', model);

const addSecurityDepositRefund = (model) => httpClient.post('/api/v2/BookingChargeItem/addSecurityDepositRefund', model);


const getOutstandingBookingChargeItemByBookingTypeValue = (bookingType, bookingTypeValue) => httpClient.get('/api/v2/BookingChargeItem/GetOutstandingBookingChargeItemByBookingTypeValue', { params: { bookingType, bookingTypeValue } });

const getOutstandingBookingChargeItemOnlyNoInvoice = (bookingId, roomStayId) => httpClient.get('/api/v2/BookingChargeItem/GetOutstandingBookingChargeItem', { params: { bookingId, roomStayId } });

const getOutstandingBookingChargeItemIncludeCN = (bookingId, roomStayId, showCN, roomTransactionId) => httpClient.get('/api/v2/BookingChargeItem/GetOutstandingBookingChargeItem', { params: { bookingId, roomStayId, showCN, roomTransactionId } });

const getOutstandingBookingChargeItemForPayment = (bookingId, roomStayId, onlyForNoInvoice, roomTransactionId) => httpClient.get('/api/v2/BookingChargeItem/GetOutstandingBookingChargeItemForPayment', { params: { bookingId, roomStayId, onlyForNoInvoice, roomTransactionId } });



const getBookingChargeItemList = (bookingId) => httpClient.get('/api/v2/BookingChargeItem/GetBookingChargeItemList', { params: { bookingId } });

const getUnpostBookingChargeItem = (bookingId, roomTransactionId) => httpClient.get('/api/v2/BookingChargeItem/getUnpostBookingChargeItem', { params: { bookingId, roomTransactionId } });

const getUnpostRoomTransactionBookingChargeItem = (bookingId, roomTransactionId) => httpClient.get('/api/v2/BookingChargeItem/getUnpostRoomTransactionBookingChargeItem', { params: { bookingId, roomTransactionId } });

const getBookingChargeItemForCancellation = (bookingId, roomStayId) => httpClient.get('/api/v2/BookingChargeItem/GetBookingChargeItemForCancellation', { params: { bookingId, roomStayId } });

const getBookingChargeItemForDiscount = (bookingId) => httpClient.get('/api/v2/BookingChargeItem/GetBookingChargeItemForDiscount', { params: { bookingId } });

const postAllCancelCharge = (bookingId, userId, userName) => httpClient.post('/api/v2/BookingChargeItem/PostAllCancelCharge', {},{ params: { bookingId, userId, userName } });

const cancelAllCancelCharge = (bookingId, userId, userName) => httpClient.post('/api/v2/BookingChargeItem/CancelAllCancelCharge', {}, { params: { bookingId, userId, userName } });

const settleBillingForCancellation = (model) => httpClient.post('/api/v2/BookingChargeItem/SettleBillingForCancellation', model);

const ex = {
  postAllCancelCharge,
  cancelAllCancelCharge,
  getOutstandingBookingChargeItem,
  getTransactionListByBookingId,
  getRoomChargeItem,
  addCancellation,
  addDiscount,
  addWaived,
  forfeitSecurityDeposit,
  getPaidBookingChargeItem,
  getSecurityDepositItems,
  addSecurityDepositRefund,
  getOutstandingBookingChargeItemByBookingTypeValue,
  postCharge,
  getOutstandingBookingChargeItemOnlyNoInvoice,
  getBookingChargeItemList,
  getOutstandingBookingChargeItemIncludeCN,
  getUnpostBookingChargeItem,
  getBookingChargeItemForCancellation,
  getBookingChargeItemForDiscount,
  transferCharge,
  getOutstandingBookingChargeItemForPayment,
  getUnpostRoomTransactionBookingChargeItem,
  settleBillingForCancellation
}

export default ex;



// WEBPACK FOOTER //
// ./src/api/booking-charge-item-api.js